export const __DEV__ = false;
export const BASE_URL = __DEV__
  ? 'http://localhost:8080/tec'
  : 'https://fsportal.dimo.com.br/tec';
